import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import { numberFormatter } from 'UI/utils';

import { ICONS_MAP } from '../constants';

import { useStyles } from './styles';

const CustomIcon = ({ classes, iconKey }) => {
  const Icon = ICONS_MAP[iconKey];
  return <Icon classes={{ root: classes.icon }} />;
};

const FORMATS = {
  none: 'none'
};

export const SummaryTotalsV2 = ({ data = [], isLoading = false }) => {
  const classes = useStyles();

  return isLoading ? (
    <CircularProgress />
  ) : (
    <List>
      {data.map(item => (
        <ListItem key={item.title}>
          {item.icon && (
            <ListItemIcon>
              <CustomIcon iconKey={item.icon} classes={classes} />
            </ListItemIcon>
          )}
          <ListItemText primary={item.title} />
          <ListItemSecondaryAction>
            <Typography variant="h5">
              {item.format === FORMATS.none
                ? item.total
                : numberFormatter(item.total, item?.format)}
            </Typography>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};
